import React, { useEffect, useState } from "react";
import "./index.scss";
import { Accordion } from "@mbank-design/design-system/components";
import { Link } from "react-router-dom";

import "./index.scss";
import { SeoFooterMake, SeoFooterMakesAndModels, SeoFooterModel } from "../../../models/seoModels";

interface SeoFooterLinksProps {
  makesAndModels: SeoFooterMakesAndModels;
}


export const SeoFooterLinks = ({ makesAndModels }: SeoFooterLinksProps) => {

  const adjustWordingForMakes = (make: string) => {
    switch (make.toUpperCase()) {
      case "FORD":
      case "FIAT":
      case "OPEL":
      case "MERCEDES-BENZ":
      case "VOLKSWAGEN":
      case "SEAT":
      case "CITROEN":
      case "HYUNDAI":
      case "JAGUAR":
      case "LAND ROVER":
      case "LEXUS":
      case "NISSAN":
      case "PEUGEOT":
        return { new: "nowy", afterlease: "poleasingowy", electric: "elektryczny", };
      case "KIA":
      case "SKODA":
      case "MAZDA":
      case "TESLA":
      case "TOYOTA":
      case "DACIA":
        return { new: "nowa", afterlease: "poleasingowa", electric: "elektryczna", };
      default:
        return { new: "nowe", afterlease: "poleasingowe", electric: "elektryczne", };
    }
  };

  return (
    <div className="seo-footer-links">
      <Accordion >
        <Accordion.Item>
          <Accordion.Header level={"2"}>
            nowe samochody
          </Accordion.Header>
          <Accordion.Content>

            <div className="seo-footer-links__list-container">
              {makesAndModels.newCars.length > 0 && makesAndModels.newCars.map((car: SeoFooterMake, index: number) => (
                car.Count < 5 ? null : (
                  <div key={car.Make + index} className="seo-footer-links__item-container">
                    <div key={car.Make} className="seo-footer-links__item">
                      <Link to={`/nowe-samochody/${car.Make.toLowerCase().replace(" ", "-")}`}>
                        {adjustWordingForMakes(car.Make).new} {car.Make.toUpperCase()}
                      </Link>
                    </div>

                    <div className="seo-footer-links__sub-list-container">
                      {car.Models.length > 0 && car.Models.map((model: SeoFooterModel) => (
                        <div key={model.Model} className="seo-footer-links__sub-item">
                          <Link to={`/nowe-samochody/${car.Make.toLowerCase().replace(" ", "-")}-${model.Model.toLowerCase().replace(" ", "-")}`}>
                            {adjustWordingForMakes(car.Make).new} {car.Make.toUpperCase().replace(" ", "-")} {model.Model.toUpperCase().replace(" ", "-")}
                          </Link>
                        </div>
                      ))}
                    </div>
                  </div>
                )
              ))}
            </div>
          </Accordion.Content>
        </Accordion.Item>
        <Accordion.Item>
          <Accordion.Header level={"2"}>
            samochody poleasingowe
          </Accordion.Header>
          <Accordion.Content>

            <div className="seo-footer-links__list-container">
              {makesAndModels.afterleaseCars.length > 0 && makesAndModels.afterleaseCars.map((car: SeoFooterMake, index: number) => (
                car.Count < 5 ? null : (
                  <div key={car.Make + index} className="seo-footer-links__item-container">
                    <div key={car.Make} className="seo-footer-links__item">
                      <Link to={`/samochody-poleasingowe/${car.Make.toLowerCase().replace(" ", "-")}`}>
                        {adjustWordingForMakes(car.Make).afterlease} {car.Make.toUpperCase()}
                      </Link>
                    </div>

                    <div className="seo-footer-links__sub-list-container">
                      {car.Models.length > 0 && car.Models.map((model: SeoFooterModel) => (
                        <div key={model.Model} className="seo-footer-links__sub-item">
                          <Link to={`/samochody-poleasingowe/${car.Make.toLowerCase().replace(" ", "-")}-${model.Model.toLowerCase().replace(" ", "-")}`}>
                            {adjustWordingForMakes(car.Make).afterlease} {car.Make.toUpperCase().replace(" ", "-")} {model.Model.toUpperCase().replace(" ", "-")}
                          </Link>
                        </div>
                      ))}
                    </div>
                  </div>
                )
              ))}
            </div>
          </Accordion.Content>
        </Accordion.Item>
        <Accordion.Item>
          <Accordion.Header level={"2"}>
            samochody elektryczne
          </Accordion.Header>
          <Accordion.Content>
            <Link className="seo-footer-links__link" to={"/nowe-samochody/elektryczne"}>
              nowe samochody elektryczne
            </Link>
            <div className="seo-footer-links__list-container">
              {makesAndModels.electricCars.NewElectricVehicles.length > 0 && makesAndModels.electricCars.NewElectricVehicles.map((car: SeoFooterMake, index: number) => (
                car.Count < 5 ? null : (
                  <div key={car.Make + index} className="seo-footer-links__item-container">
                    <div className="seo-footer-links__item">
                      <Link to={`/samochody-elektryczne/${car.Make.toLowerCase().replace(" ", "-")}`}>
                        {adjustWordingForMakes(car.Make).electric} {car.Make.toUpperCase()}
                      </Link>
                    </div>

                    <div className="seo-footer-links__sub-list-container">
                      {car.Models.length > 0 && car.Models.map((model: SeoFooterModel) => (
                        <div key={model.Model} className="seo-footer-links__sub-item">
                          <Link to={`/samochody-elektryczne/${car.Make.toLowerCase().replace(" ", "-")}-${model.Model.toLowerCase().replace(" ", "-")}`}>
                            {adjustWordingForMakes(car.Make).new} {car.Make.toUpperCase().replace(" ", "-")} {model.Model.toUpperCase().replace(" ", "-")}
                          </Link>
                        </div>
                      ))}
                    </div>
                  </div>
                )
              ))}
            </div>
            <Link className="seo-footer-links__link" to={"/samochody-poleasingowe/elektryczne"}>
              elektryczne samochody poleasingowe
            </Link>
            <div className="seo-footer-links__list-container">
              {makesAndModels.electricCars.AfterleaseElectricVehicles.length > 0 && makesAndModels.electricCars.AfterleaseElectricVehicles.map((car: SeoFooterMake, index: number) => (
                car.Count < 5 ? null : (
                  <div key={car.Make + index} className="seo-footer-links__item-container">
                    <div key={car.Make + index} className="seo-footer-links__item">
                      <Link to={`/samochody-elektryczne/${car.Make.toLowerCase().replace(" ", "-")}`}>
                        {adjustWordingForMakes(car.Make).electric} {car.Make.toUpperCase()}
                      </Link>
                    </div>

                    <div className="seo-footer-links__sub-list-container">
                      {car.Models.length > 0 && car.Models.map((model: SeoFooterModel, index: number) => (
                        <div key={model.Model + index} className="seo-footer-links__sub-item">
                          <Link to={`/samochody-elektryczne/${car.Make.toLowerCase().replace(" ", "-")}-${model.Model.toLowerCase().replace(" ", "-")}`}>
                            {adjustWordingForMakes(car.Make).afterlease} {car.Make.toUpperCase().replace(" ", "-")} {model.Model.toUpperCase().replace(" ", "-")}
                          </Link>
                        </div>
                      ))}
                    </div>
                  </div>
                )
              ))}
            </div>
          </Accordion.Content>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};